import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as rent_contracts_api from '../Api/rent_contracts_api';
import * as rent_contract_workflows_api from '../Api/rent_contract_workflows_api';
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types

var moment = require("moment-timezone");
//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface RentContractMoniesState {
    // rent_contract_monies:any;
    rent_contracts_list: any;
    rent_contracts_list2: any;
    formData: any;

}
const initialState: RentContractMoniesState = {

    rent_contracts_list: [],
    rent_contracts_list2: [],
    formData: {
        chinkaku_mi : true,
        chinkaku_zumi : false,
        chinkaku_zumi_henkou : true,
        application_date_start : null,
        application_date_end : null,
        contract_date_start : moment().add(-1, "years").startOf('month').format("YYYY-MM-DD"),
        contract_date_end : null,
        contractor_name1 : "",
        building_name : "",
        cloudsign_completed_at_start : null,
        cloudsign_completed_at_end : null,
        payment_type : [],
        apply_payment_type : [],
        month_payment_type : [],
        cancel_date_start : moment().add(-7, "days").format("YYYY-MM-DD"),
        cancel_date_end : null,
        cancel_only : false,
        // is_cancel : null,
    },

}



///action 
const actionCreator = actionCreatorFactory();

export const get_rent_contracts_list = actionCreator<any>('GET_RENT_CONTRACTS_LIST');
export const change_rent_contracts_list = actionCreator<any>("CHANGE_RENT_CONTRACTS_LIST");
export const change_rent_contracts_list2 = actionCreator<any>("CHANGE_RENT_CONTRACTS_LIST2");
export const search_rent_contracts_list = actionCreator<any>('SEARCH_RENT_CONTRACTS_LIST');

export const change_formData = actionCreator<any>('CHANGE_FORMDATA');

export const update_rent_contracts = actionCreator('UPDATE_RENT_CONTRACTS');



export const officecontractsReducer = reducerWithInitialState(initialState)
    .case(change_rent_contracts_list, (state, payload) => ({ ...state, rent_contracts_list: payload }))
    .case(change_rent_contracts_list2, (state, payload) => ({ ...state, rent_contracts_list2: payload }))
    .case(change_formData, (state, payload) => ({ ...state, formData: payload }))



// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const OfficeContractsSaga = [
    takeEvery('GET_RENT_CONTRACTS_LIST', handle_get_rent_contracts_list),

    takeEvery('SEARCH_RENT_CONTRACTS_LIST', handle_search_rent_contracts_list),

    takeEvery('UPDATE_RENT_CONTRACTS', handle_update_rent_contracts),
];
// export default masterSaga;



function* handle_get_rent_contracts_list(action: any) :any {
    console.log(action.payload)

    const state = yield select();
    let formData = state.OfficeContracts.formData
    // let search_name = state.contractsearchReducer.search_name
    // let search_contract_date_start = state.contractsearchReducer.search_contract_date_start
    // let search_contract_date_end = state.contractsearchReducer.search_contract_date_end
    // let search_tatemono_name = state.contractsearchReducer.search_tatemono_name

    const { payload, error } = yield call(rent_contracts_api.list, formData);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(change_rent_contracts_list(payload));
        yield put(change_rent_contracts_list2(payload));
        yield put(search_rent_contracts_list(payload));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

function* handle_search_rent_contracts_list(action: any): any {
    yield put(change_rent_contracts_list([]));

    const state = yield select();   // store.getState()と同じ

    let rent_contracts_list = state.OfficeContracts.rent_contracts_list2
    let formData = state.OfficeContracts.formData


    if (formData.chinkaku_mi && !formData.chinkaku_zumi) {
        if (formData.chinkaku_zumi_henkou) {
            // alert(1)
            rent_contracts_list = rent_contracts_list.filter((a: any) => !(a.bk_no > 0) || a.cancel_date || (a.ver != a.log_confirm))
        }else{
            // alert(2)
            rent_contracts_list = rent_contracts_list.filter((a: any) => (!(a.bk_no > 0) || a.cancel_date))
        }
    }

    if (!formData.chinkaku_mi && formData.chinkaku_zumi) {
        if (formData.chinkaku_zumi_henkou) {
            // alert(3)
            rent_contracts_list = rent_contracts_list.filter((a: any) => ((a.bk_no && a.bk_no > 0) || a.cancel_date) && (a.ver != a.log_confirm))
        }else{
            // alert(4)
            rent_contracts_list = rent_contracts_list.filter((a: any) => ((a.bk_no && a.bk_no > 0) || a.cancel_date))
        }
    }

    if (formData.chinkaku_mi && formData.chinkaku_zumi) {
        if (formData.chinkaku_zumi_henkou) {
            // alert(5)
            rent_contracts_list = rent_contracts_list.filter((a: any) => (a.cancel_date || (a.ver != a.log_confirm)))
        }else{
            // alert(6)
        }
    }

    if (!formData.chinkaku_mi && !formData.chinkaku_zumi) {
        if (formData.chinkaku_zumi_henkou) {
            // alert(7)
            rent_contracts_list = rent_contracts_list.filter((a: any) => ((a.bk_no && a.bk_no > 0) || a.cancel_date) && (a.ver != a.log_confirm))
        }else{
            // alert(8)

        }
    }

    if (formData.contractor_name1) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => 
            (a.contractor_name1 && han2zen(kanaToHira(hankana2Zenkana(a.contractor_name1))).indexOf(han2zen(kanaToHira(hankana2Zenkana(formData.contractor_name1)))) !== -1) ||
          (a.contractor_kana1 && kanaToHira(hankana2Zenkana(a.contractor_kana1)).indexOf(kanaToHira(hankana2Zenkana(formData.contractor_name1))) !== -1)//名前　〇
        )
    }

    if (formData.building_name) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => 
            (a.building_name && han2zen(kanaToHira(hankana2Zenkana(a.building_name))).indexOf(han2zen(kanaToHira(hankana2Zenkana(formData.building_name)))) !== -1)
        )
    }

    // 申込日
    if (formData.application_date_start) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") >= moment(formData.application_date_start).format("YYYYMMDD"))
    }
    
    if (formData.application_date_end) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") <= moment(formData.application_date_end).format("YYYYMMDD"))
    }

    // 契約日
    if (formData.contract_date_start) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") >= moment(formData.contract_date_start).format("YYYYMMDD"))
    }
    
    if (formData.contract_date_end) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") <= moment(formData.contract_date_end).format("YYYYMMDD"))
    }

    // 締結日
    if (formData.cloudsign_completed_at_start) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.cloudsign_completed_at && moment(a.cloudsign_completed_at).format("YYYYMMDD") >= moment(formData.cloudsign_completed_at_start).format("YYYYMMDD"))
    }
    
    if (formData.cloudsign_completed_at_end) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.cloudsign_completed_at && moment(a.cloudsign_completed_at).format("YYYYMMDD") <= moment(formData.cloudsign_completed_at_end).format("YYYYMMDD"))
    }

    // 支払区分
    if (formData.payment_type.length > 0) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => formData.payment_type.includes(a.payment_type))
    }

    // 支払予定区分
    if (formData.apply_payment_type.length > 0) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => formData.apply_payment_type.includes(a.apply_payment_type))
    }

    // 月々支払区分
    if (formData.month_payment_type.length > 0) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => formData.month_payment_type.includes(a.month_payment_type))
    }

    // キャンセル日
    if (formData.cancel_date_end) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.cancel_date && moment(a.cancel_date).format("YYYYMMDD") <= moment(formData.cancel_date_end).format("YYYYMMDD"))
    }

    if (formData.cancel_only) {
        rent_contracts_list = rent_contracts_list.filter((a: any) => a.cancel_date)
    }


    yield put(change_rent_contracts_list(rent_contracts_list));

    function kanaToHira(str: string) {
        return String(str).replace(/[\u30a1-\u30f6]/g, function (match) {
          var chr = match.charCodeAt(0) - 0x60;
          return String.fromCharCode(chr);
        });
      }
    
    
      function han2zen(str: string) {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
      }
      function hankana2Zenkana(str: string) {
        var kanaMap: any = {
          'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
          'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
          'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
          'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
          'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
          'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
          'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
          'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
          'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
          'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
          'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
          'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
          'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
          'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
          'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
          'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
          'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
          'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
          '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
        };
    
        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        if (str) {
          return str
            .replace(reg, function (match) {
              return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
        } else {
          return str
        }
      };
}

// 基本情報更新
function* handle_update_rent_contracts(action: any): any {

    // alert(action.payload)

    const state = yield select();

    const { payload, error } = yield call(rent_contract_workflows_api.update, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        let rent_contracts_list2 = state.OfficeContracts.rent_contracts_list2

        // 一覧の情報更新
        rent_contracts_list2 = rent_contracts_list2.map(function (value: any) {
            if (value.workflow_id === action.payload) {
                // alert(payload.title)
                value.log_confirm = value.ver
            }
            return value
        })

        // 情報更新
        yield put(change_rent_contracts_list2(rent_contracts_list2));
        yield put(search_rent_contracts_list(rent_contracts_list2));



    } else {

    }
}



